const CHECKED = "c";
const NOT_CHECKED = "n";

const ACCESSIBLE = "a";
const INACCESSIBLE = "i";
const TID_NOT_FOUND = "tn";
const MERCHANT_NOT_AT_LOCATION = "mn";

const BANK_TO_PROVIDE_SIM = "b";
const PTAD_INTERVENTION = "p";
const NIBS_BANK_INTERVENTION = "n";
const ADDRESS_UPDATE_REQUIRED = "a";
const BANK_TO_REPLACE = "b";
const BANK_TO_REPLACE_FAULTY_PART = "bf";
const BANK_TO_CONFIRM = "bc";
const BANK_INTERVENTION = "bi";
const BANK_TO_PROVIDE_REPLACEMENT = "br";
const BANK_TO_PROVIDE_ACTIVE_NUMBER = "bn";
const BANK_TO_RELOAD_SIM = "bs";
const BANK_TO_CONFIRM_WHERE_TID_IN_USE = "bt";
const PTSP_TO_REVISIT = "pr";
const PTSP_TO_CONFIRM = "pc";
const OK = "ok";
const OTHER = "ot";

const ETISALAT = "e";
const MTN = "m";
const AIRTEL = "a";
const GLO = "g";
const WIFI = "w";
const LAN = "l";

const BATTERY = "bt";
const PAPER_ROLL = "p";
const PRINTER_ROLLER = "pr";
const BACK_COVER = "bc";
const PRINTER_COVER = "pc";
const CHARGER = 'ch';

const DAILY = "d";
const WEEKLY = "w";
const BI_MONTHLY = "b";

const PTSP_ADMIN = 1;
const ROUTE_MARSHALL = 2;
const CUSTOMER_CARE = 3;

const TOP_10 = 't10'
const TOP_15 = 't15'
const TOP_20 = 't20'
const TOP_25 = 't25'
const TOP_30 = 't30'
const TOP_35 = 't35'
const TOP_40 = 't40'

const ABIA = 'AB'
const ADAMAWA = 'AD'
const ABUJA = 'FC'
const AKWAIBOM = 'AK'
const ANAMBRA = 'AN'
const BAUCHI = 'BA'
const BAYELSA = 'BAY'
const BENUE = 'BE'
const BORNO = 'BO'
const CROSSRIVER = 'CR'
const DELTA = 'DE'
const EBONYI = 'EB'
const ENUGU = 'EN'
const EDO = 'ED'
const EKITI = 'EK'
const GOMBE = 'GO'
const IMO = 'IM'
const JIGAWA = 'JI'
const KADUNA = 'KD'
const KANO = 'KN'
const KATSINA = 'KT'
const KEBBI = 'KE'
const KOGI = 'KO'
const KWARA = 'KW'
const LAGOS = 'LA'
const NASARAWA = 'NA'
const NIGER = 'NI'
const OGUN = 'OG'
const ONDO = 'ON'
const OSUN = 'OS'
const OYO = 'OY'
const PLATEAU = 'PL'
const RIVERS = 'RI'
const SOKOTO = 'SO'
const TARABA = 'TA'
const YOBE = 'YO'
const ZAMFARA = 'ZA'

export const USER_TYPE_CHOICES = {
  "PTSP Admin": PTSP_ADMIN,
  "Route Marshal": ROUTE_MARSHALL,
  "Customer Care": CUSTOMER_CARE
};

export const DATA_PROVIDERS = [
  { name: "9Mobile", value: ETISALAT },
  { name: "Airtel", value: AIRTEL },
  { name: "MTN", value: MTN },
  { name: "Glo", value: GLO },
  { name: 'WIFI', value: WIFI },
  { name: 'LAN', value: LAN },
];

export const ITEM_CHOICES = [
  { name: "Battery", value: BATTERY },
  { name: "Paper Roll", value: PAPER_ROLL },
  { name: "Printer Roller", value: PRINTER_ROLLER },
  { name: "Back Cover", value: BACK_COVER },
  { name: "Printer Cover", value: PRINTER_COVER },
  { name: "Charger", value: CHARGER }
];

export const ACTION_CHOICES = [
  { name: "Bank to Provide Sim", value: BANK_TO_PROVIDE_SIM },
  { name: "PTAD Intervention", value: PTAD_INTERVENTION },
  { name: "NIBSS/Bank Intervention", value: NIBS_BANK_INTERVENTION },
  { name: "Address Update Required", value: ADDRESS_UPDATE_REQUIRED },
  { name: "Bank to Replace", value: BANK_TO_REPLACE },
  { name: "Bank to Replace Faulty Part", value: BANK_TO_REPLACE_FAULTY_PART },
  { name: "Bank to Confirm", value: BANK_TO_CONFIRM },
  { name: "Bank Intervention", value: BANK_INTERVENTION },
  { name: "Bank to Provide Replacement", value: BANK_TO_PROVIDE_REPLACEMENT },
  { name: "Bank to Provide Active number", value: BANK_TO_PROVIDE_ACTIVE_NUMBER },
  { name: "Bank to Reload the Sim", value: BANK_TO_RELOAD_SIM },
  { name: "Bank to Confirm Where the TID is in Use", value: BANK_TO_CONFIRM_WHERE_TID_IN_USE },
  { name: "PTSP to Revisit", value: PTSP_TO_REVISIT },
  { name: "PTSP to Confirm", value: PTSP_TO_CONFIRM },
  { name: "Ok", value: OK },
  { name: "Other", value: OTHER }
];

export const COMMENT_CHOICES = [
  { name: "Accessible", value: ACCESSIBLE },
  { name: "Inaccessible", value: INACCESSIBLE },
  { name: "TID not found", value: TID_NOT_FOUND },
  { name: "Merchant not at location", value: MERCHANT_NOT_AT_LOCATION },
];

export const STATUS_CHOICES = [
  { name: "Checked", value: CHECKED },
  { name: "Not Checked", value: NOT_CHECKED }
];

export const REMARK_CHOICES = [
  { name: "Working Successful", value: "WORKING_SUCCESSFUL" },
  { name: "Working but not in use", value: "WORKING_BUT_NOT_IN_USE" },
  { name: "Insufficient funds", value: "INSUFFICIENT_FUNDS" },
  { name: "Address Incomplete", value: "ADDRESS_INCOMPLETE" },
  { name: "Application Issue on CitiServe", value: "APPLICATION_ISSUE_ON_CITISERVE" },
  { name: "Application Issue on ETOP", value: "APPLICATION_ISSUE_ON_ETOP" },
  { name: "Application Issue on Global Accelerex", value: "APPLICATION_ISSUE_ON_GLOBAL_ACCELEREX" },
  { name: "Application Issue on Interswitch", value: "APPLICATION_ISSUE_ON_INTERSWITCH" },
  { name: "Application Issue on UPSL", value: "APPLICATION_ISSUE_ON_UPSL" },
  { name: "Bad Battery", value: "BAD_BATTERY" },
  { name: "Bad Terminal", value: "BAD_TERMINAL" },
  { name: "Battery Under Volt", value: "BATTERY_UNDER_VOLT" },
  { name: "Blank Screen", value: "BLANK_SCREEN" },
  { name: "Charger Issue", value: "CHARGER_ISSUE" },
  { name: "Charging Port", value: "CHARGING_PORT" },
  { name: "Comm Error", value: "COMM_ERROR" },
  { name: "Contact Not Reachable", value: "CONTACT_NOT_REACHABLE" },
  { name: "Create Link Timeout", value: "CREATE_LINK_TIMEOUT" },
  { name: "Credit Exhausted on 123456789", value: "CREDIT_EXHAUSTED" },
  { name: "Error Unpacking Response", value: "ERROR_UNPACKING_RESPONSE" },
  { name: "Error in SIM Module", value: "ERROR_IN_SIM_MODULE" },
  { name: "Error receiving response", value: "ERROR_RECEIVING_RESPONSE" },
  { name: "Keypad Issue", value: "KEYPAD_ISSUE" },
  { name: "Loss of PoS", value: "LOSS_OF_POS" },
  { name: "Mainboard", value: "MAINBOARD" },
  { name: "Network Issue", value: "NETWORK_ISSUE" },
  { name: "Net Connect Failed", value: "NET_CONNECT_FAILED" },
  { name: "Not Deployed", value: "NOT_DEPLOYED" },
  { name: "Paper roll", value: "PAPER_ROLL" },
  { name: "Ped Tampered", value: "PED_TAMPERED" },
  { name: "PoS Attacked", value: "POS_ATTACKED" },
  { name: "PoS got burnt", value: "POS_GOT_BURNT" },
  { name: "Printer Cover", value: "PRINTER_COVER" },
  { name: "Printer Roller", value: "PRINTER_ROLLER" },
  { name: "Routing Error", value: "ROUTING_ERROR" },
  { name: "Settlement Issue", value: "SETTLEMENT_ISSUE" },
  { name: "Signal Strength", value: "SIGNAL_STRENGTH" },
  { name: "Simon Battery", value: "SIMON_BATTERY" },
  { name: "Sim Slot", value: "SIM_SLOT" },
  { name: "Switch Issue(NIBBS)", value: "SWITCH_ISSUE(NIBBS)" },
  { name: "Switch Issue on Interswitch", value: "SWITCH_ISSUE_ON_INTERSWITCH" },
  { name: "Terminal Custodian is not available", value: "TERMINAL_CUSTODIAN_NOT_AVAILABLE" },
  { name: "Terminal not powered up", value: "TERMINAL_NOT_POWERED_UP" },
  { name: "TMK Buffer Error", value: "TMK_BUFFER_ERROR" },
  { name: "Unable to read card", value: "UNABLE_TO_READ_CARD" },
  { name: "Wave Lost", value: "WAVE_LOST" },
  { name: "Other", value: "OTHER" },
];

export const STATE_CHOICES = [
  { name: 'Abia', value: ABIA },
  { name: 'Adamawa', value: ADAMAWA },
  { name: 'Abuja', value: ABUJA },
  { name: 'Akwa-ibom', value: AKWAIBOM },
  { name: 'Anambra', value: ANAMBRA },
  { name: 'Bauchi', value: BAUCHI },
  { name: 'Bayelsa', value: BAYELSA },
  { name: 'Benue', value: BENUE },
  { name: 'Borno', value: BORNO },
  { name: 'Cross-river', value: CROSSRIVER },
  { name: 'Delta', value: DELTA },
  { name: 'Ebonyi', value: EBONYI },
  { name: 'Enugu', value: ENUGU },
  { name: 'Edo', value: EDO },
  { name: 'Ekiti', value: EKITI },
  { name: 'Gombe', value: GOMBE },
  { name: 'Imo', value: IMO },
  { name: 'Jigawa', value: JIGAWA },
  { name: 'Kaduna', value: KADUNA },
  { name: 'Kano', value: KANO },
  { name: 'Katsina', value: KATSINA },
  { name: 'Kebbi', value: KEBBI },
  { name: 'Kogi', value: KOGI },
  { name: 'Kwara', value: KWARA },
  { name: 'Lagos', value: LAGOS },
  { name: 'Nasarawa', value: NASARAWA },
  { name: 'Niger', value: NIGER },
  { name: 'Ogun', value: OGUN },
  { name: 'Ondo', value: ONDO },
  { name: 'Osun', value: OSUN },
  { name: 'Oyo', value: OYO },
  { name: 'Plateau', value: PLATEAU },
  { name: 'Rivers', value: RIVERS },
  { name: 'Sokoto', value: SOKOTO },
  { name: 'Taraba', value: TARABA },
  { name: 'Yobe', value: YOBE },
  { name: 'Zamfara', value: ZAMFARA },
]


export const MONTH_CHOICES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec"
];

export const VISITATION_CHOICES = [
  { name: "Daily", value: DAILY },
  { name: "Weekly", value: WEEKLY },
  { name: "Twice a Month", value: BI_MONTHLY },
];

export const BANK_CHOICES = {
  "Access": 2,
  "Diamond": 3,
  "Ecobank": 4,
  "Ecobank 2": 5,
  "Fcmb":	6,
  "Fidelity":	7,
  "Firstbank":	8,
  "Gtbank":	9,
  "Heritage":	10,
  "Jaiz":	11,
  "Keystone":	12,
  "Skyebank":	13,
  "Stanbic-Ibtc":	14,
  "Sterling":	15,
  "Uba":	16,
  "Union":	2032,
  "Unity":	2201,
  "Wema":	2035,
  "Zenith":	2057,
}

export const CATEGORY_CHOICES = [
  { name: 'Top 10%', value: TOP_10 },
  { name: 'Top 15%', value: TOP_15 },
  { name: 'Top 20%', value: TOP_20 },
  { name: 'Top 25%', value: TOP_25 },
  { name: 'Top 30%', value: TOP_30 },
  { name: 'Top 35%', value: TOP_35 },
  { name: 'Top 40%', value: TOP_40 },
]

export const convertUTCTime = (UTCDateTime) => {
  const date = new Date(UTCDateTime)
  return `${date.toDateString()} ${date.toLocaleTimeString()}`
}

export const paramJoin = args => {
  // const params = Object.entries(args).filter(param => {
  //   return param[1] != undefined
  // }).map(param => {
  //   console.log('param', param)
  //   return `${param[0]}=${param[1]}`
  // }).join('&')
  // return params

  const params = Object.entries(args).reduce((acc, param, index, array) => {
    if (param[1]) acc += `${param[0]}=${param[1]}&`
    if (index === array.length-1) { 
      return acc.slice(0, -1)
    }
    return acc
  }, "")
  return params
}

export const choiceToDict = (choiceArray) => {
  const solu = choiceArray.reduce((ret, cur) => {
      ret[cur.value] = cur.name
      return ret
  }, {})
  return solu;
}

import { DISPLAY_NOTIFICATION } from '@/store/actions/common'
import store from "@/store"

export const showSnackbar = ({message, url='', color='primary', commit=false, timeout=5000} = {}) => {
  // @click="showSnackbar({
    // message:marshal.first_name,
    // url:'/admin',
    // color:'primary darken-1', 
    // :10000})"
  let notification = {
      'message': message,
      'url': url,
      'timeout': timeout,
      'color': color,
      'show': true,
      'commit': commit
  }
  store.dispatch(DISPLAY_NOTIFICATION, notification)
}

export const TOKEN_EXPIRATION_DELTA = 1800000

export default {
  USER_TYPE_CHOICES,
  DATA_PROVIDERS,
  ITEM_CHOICES,
  ACTION_CHOICES,
  COMMENT_CHOICES,
  STATUS_CHOICES,
  REMARK_CHOICES,
  MONTH_CHOICES,
  VISITATION_CHOICES,
  CATEGORY_CHOICES,
  STATE_CHOICES,
  convertUTCTime,
  showSnackbar,
  paramJoin,
  choiceToDict,
}
